import { render, staticRenderFns } from "./psuBzjAffirmForm.vue?vue&type=template&id=5cb107df&scoped=true"
import script from "./psuBzjAffirmForm.vue?vue&type=script&lang=js"
export * from "./psuBzjAffirmForm.vue?vue&type=script&lang=js"
import style0 from "./psuBzjAffirmForm.vue?vue&type=style&index=0&id=5cb107df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb107df",
  null
  
)

export default component.exports